import { render, staticRenderFns } from "./Change.vue?vue&type=template&id=c7a4ba7a&scoped=true"
import script from "./Change.vue?vue&type=script&lang=js"
export * from "./Change.vue?vue&type=script&lang=js"
import style0 from "./Change.vue?vue&type=style&index=0&id=c7a4ba7a&prod&lang=less&scoped=true"
import style1 from "./Change.vue?vue&type=style&index=1&id=c7a4ba7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a4ba7a",
  null
  
)

export default component.exports